<div class="wrapper">
    <p class="font-weight-bold" id="title">
        Produkte
    </p>
    <div class="card">
        <div class="card-body">

            <app-table-header
                    [(pageIndex)]="productsService.pageIndex"
                    [pageCount]="productsService.data?.pageCount"
                    [error]="productsService.error"
                    [loading]="productsService.loading"
                    [(filter)]="productsService.filter"
                    filterPlaceholder="Modellnummer Intern"
                    (reload)="productsService.loadProducts()"
                    [columnFilters]="productsService.columnFilters"
                    [columnFiltersDisplay]="productsService.columnFiltersDisplay"
                    [(columnFilterValues)]="productsService.columnFilterValues"
            >
            </app-table-header>

            <ng-container *ngIf="productsService.data != null">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>
                            <p>Modellnummer Intern</p>
                        </th>
                        <th>
                            <p>Verkaufspreis</p>
                        </th>
                        <th>
                            <p>Einkaufspreis</p>
                        </th>
                        <th>
                            <button class="btn btn-sm btn-outline-primary"
                                    (click)="toggleEdit()">{{this.edit ? "Fertig" : "Bearbeiten"}}</button>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let product of productsService.data.products">
                        <td>
                            <p>
                                <a [href]="'/api/products/' + product.id">
                                    {{product.modellnummerIntern}}
                                </a>
                            </p>
                        </td>
                        <td>
                            <p>{{product.verkaufspreis[this.productsService.columnFilterValues[0]][this.productsService.columnFilterValues[2]][this.productsService.columnFilterValues[1]] | euro}}</p>
                        </td>
                        <td>
                            <p>{{product.einkaufspreis[this.productsService.columnFilterValues[2]][this.productsService.columnFilterValues[1]] | euro}}</p>
                        </td>
                        <td>
                            <button class="btn btn-sm btn-outline-danger" (click)="deleteProduct(product)"
                                    *ngIf="this.edit">Löschen</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>


</div>
